var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card-title",
                {
                  staticClass: "pb-6 pt-0"
                },
                [_vm._v(" Create New Support Ticket ")]
              ),
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-header",
                    {
                      staticClass: "mb-5"
                    },
                    [_vm._v(" Create New Ticket ")]
                  ),
                  _c(
                    "gg-card-text",
                    [
                      _c(
                        "v-form",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("gg-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.rules.department,
                                        expression: "rules.department"
                                      }
                                    ],
                                    attrs: {
                                      outlined: "",
                                      label: "Department",
                                      items: _vm.departments,
                                      "data-vv-name": "department",
                                      "data-vv-as": "Department",
                                      "error-messages": _vm.errors.collect(
                                        "department"
                                      )
                                    },
                                    model: {
                                      value: _vm.model.department,
                                      callback: function callback($$v) {
                                        _vm.$set(_vm.model, "department", $$v)
                                      },
                                      expression: "model.department"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("gg-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.rules.subject,
                                        expression: "rules.subject"
                                      }
                                    ],
                                    attrs: {
                                      outlined: "",
                                      label: "Subject",
                                      "data-vv-name": "subject",
                                      "data-vv-as": "Subject",
                                      "error-messages": _vm.errors.collect(
                                        "subject"
                                      )
                                    },
                                    model: {
                                      value: _vm.model.subject,
                                      callback: function callback($$v) {
                                        _vm.$set(_vm.model, "subject", $$v)
                                      },
                                      expression: "model.subject"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.showServices
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "py-0",
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c("gg-select", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: _vm.isServiceIsRequired,
                                            expression: "isServiceIsRequired"
                                          }
                                        ],
                                        attrs: {
                                          outlined: "",
                                          label: "Related Service",
                                          items: _vm.services_items,
                                          "item-value": "id",
                                          "data-vv-name": "service",
                                          "data-vv-as": "Service",
                                          "error-messages": _vm.errors.collect(
                                            "service"
                                          )
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function fn(_ref) {
                                                var item = _ref.item
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.name) +
                                                      " " +
                                                      _vm._s(
                                                        item.domain
                                                          ? "-" + item.domain
                                                          : ""
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "item",
                                              fn: function fn(_ref2) {
                                                var item = _ref2.item
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.name) +
                                                      " " +
                                                      _vm._s(
                                                        item.domain
                                                          ? "-" + item.domain
                                                          : ""
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          4060450620
                                        ),
                                        model: {
                                          value: _vm.model.service,
                                          callback: function callback($$v) {
                                            _vm.$set(_vm.model, "service", $$v)
                                          },
                                          expression: "model.service"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("contacts", {
                                    model: {
                                      value: _vm.model.contacts,
                                      callback: function callback($$v) {
                                        _vm.$set(_vm.model, "contacts", $$v)
                                      },
                                      expression: "model.contacts"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: {
                                    cols: "12",
                                    id: "message"
                                  }
                                },
                                [
                                  _c("gg-input-label", [
                                    _vm._v("Describe your issue here")
                                  ]),
                                  _c("v-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.rules.message,
                                        expression: "rules.message"
                                      }
                                    ],
                                    ref: "message",
                                    staticClass: "gg-input",
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      autofocus: _vm.messageAutofocus,
                                      "data-vv-name": "Message",
                                      "error-messages": _vm.errors.collect(
                                        "Message"
                                      )
                                    },
                                    model: {
                                      value: _vm.model.body,
                                      callback: function callback($$v) {
                                        _vm.$set(_vm.model, "body", $$v)
                                      },
                                      expression: "model.body"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("attachments", {
                                    on: {
                                      update: _vm.setAttachment
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c(
                                    "gg-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        tile: "",
                                        loading: _vm.loading
                                      },
                                      on: {
                                        click: _vm.openTicket
                                      }
                                    },
                                    [_vm._v("Create Ticket")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }